export default "__VITE_ASSET__7bb2626b__"